import { render, staticRenderFns } from "./FBAoderedit.vue?vue&type=template&id=6cfaa857&scoped=true&"
import script from "./FBAoderedit.vue?vue&type=script&lang=js&"
export * from "./FBAoderedit.vue?vue&type=script&lang=js&"
import style0 from "./FBAoderedit.vue?vue&type=style&index=0&id=6cfaa857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfaa857",
  null
  
)

export default component.exports